// extracted by mini-css-extract-plugin
export var black = "_j-6";
export var brand = "_j-1";
export var ddefault = "_j-0";
export var error = "_j-3";
export var gray = "_j-2";
export var highContrast = "_j-8";
export var outline = "_j-7";
export var success = "_j-5";
export var warning = "_j-4";